"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
var query_builder_1 = require("../query-builder");
var sanityQuery = function (query, projection) {
    var parts = query ? [(0, query_builder_1.buildQuery)(query)] : [];
    if (query && projection)
        parts.push("{".concat(projection, "}"));
    return parts.join(' ');
};
/**
 * A function that fetches documents from Sanity.
 * @param client - A Sanity client.
 * @param query - A query object.
 * @param projection - A projection string. (Optional).
 * @returns A promise that resolves to a document or an array of documents.
 * @example
 * const client = sanityClient({...})
 * const query = {
 *  constraints: [
 *   filter('name', 'match', 'John'),
 *   order('age', 'asc'),
 *   slice(0, 10),
 *  ],
 * }
 * const projection = '_id, name, age'
 * const documents = await fetch(client, query, projection)
 * console.log(documents)
 * => [{_id: '...', name: 'John', age: 42}, ...]
 */
var fetch = function (client, query, projection) {
    return client.fetch(sanityQuery(query, projection));
};
exports.fetch = fetch;
//# sourceMappingURL=query.js.map